import { API_REFERENCE } from '../utilities/constant_api';
import { formPost, htmlGet } from '../components/ajax';
import { formatPhoneNumber, setvariableValue } from '../utilities/utility';
import { resolveAddSelectDoctor,RECONFIRM_SIGINING_PHYSICIAN } from '../utilities/constant_config';

(function($, doc) {
  var cboxOptions = {
    maxWidthLg: '900px',
    maxHeightLg: '800px',
    maxWidthMd: '600px',
    maxHeightMd: '500px',
    maxWidthSm: 'auto',
    maxHeightSm: 'auto'
  };
  const noRecordDoctor = '.noRecordDiv_doctorFlow';
  const doctorRowHead = '.doctor_row-header';
  const initialDoctorDiv = '.initial-doctor-div';
  const bodySection = '.section-body';
  const physicianForm = '.saveSearchPhysician';
  const physicianFormSearchCancel = '.checkout-search-physician-form__cancel';
  const addNewDoctor = '.add_new_doctor';
  const addNewPhysician = 'addNewPhysician';
  const globalErrorMsg = '.global-error-message';
  const saveSearchPhysician = '.checkout-Add-Provider-NextBtn';
  const errorPageAddDoctor = '.error_doctor_add_button';
  const errorPageSelectDoctor = '#selectDoctor';
  const errorPageNextButton = '.error-checkout-physician-view-next-step';
  const doctorRltId = '#customerRltId';
  const resolutionType = '#resolutionType';
  const showDoctorDetail = '.show-doctor-details';
  const hideDoctorDetail = '.hide-doctor-details';
  const searchDoctorListReview =
    '.account-addnewdoc-search-results-table-additional-container';
  const searchDoctorListRowContainer =
    '.account-addnewdoc-search-results-table-body';
  const productCodeValue = '.product-item__nbr';
  const defaultDoctor = '.account-doctor-default';
  const selectResolutionOptions = '.select-error-resolution-option';
  const checkoutSearchPhysicianCancel =
    '.checkout-search-physician-form__cancel_dis';
    const physicianPhoneInfo = '#physicianPhoneInfo';
    const physicianFaxInfo = '#physicianFaxInfo';
    const physicianPhone = '.physician-phone';
    const physicianFax ='.physician-fax';
  let resolutionCode;
  let productCode;
  let createNewPhysicianSearchAjaxFlag = true;
  let cancelPhysicianSearchAjaxFlag = true;
  let nextStepButtonFlag = false;
  let noRecordError = $(noRecordDoctor)
    .find('.noRecordError_span')
    .text()
    .trim();
  var multiAddressArray = [];
  var multiAddressObj = {};
  var randomNumberRegex = new RegExp('^(?!([0-9])\\1{2}\\.\\1{3}\\.\\1{4})\\d{3}\\.\\d{3}\\.\\d{4}$');
  function showNewPhysician() {
    const viewPhysiciansUrl = `${API_REFERENCE.checkoutPhysician.viewPhysicians}`;
    if (!cancelPhysicianSearchAjaxFlag) return false;
    cancelPhysicianSearchAjaxFlag = false;
    htmlGet(viewPhysiciansUrl)
      .then(responseData => {
        createNewPhysicianSearchAjaxFlag = true;
        cancelPhysicianSearchAjaxFlag = true;
        const response = ACC.sanitizer.sanitizeHtmlDeeply(responseData);
        if (response) {
          $(noRecordDoctor).hide();
          $(doctorRowHead).html(
            $(response)
              .find(doctorRowHead)
              .html()
          );
          $(initialDoctorDiv).html(
            $(response)
              .find(initialDoctorDiv)
              .html()
          );
          $(initialDoctorDiv)
            .find(bodySection)
            .addClass('initial-Doctor-Block-Body');
          $('#createState,#searchPhysician_state').selectmenu();
          $('.formatDoctorPhone').val(function(index, text) {
            return formatPhoneNumber(text);
          });
        } else {
          $(noRecordDoctor)
            .show()
            .find('.noRecordError_span')
            .text(noRecordError);
        }
      })
      .catch(error => {
        createNewPhysicianSearchAjaxFlag = true;
        cancelPhysicianSearchAjaxFlag = true;
      });
  }

  function submitSaveSearchPhysician() {
    const physicianFormToBeSaved = $('input[name=doctorList]:checked')
      .closest('.account-addnewdoc-search-results-table-body')
      .find(physicianForm);
    if (physicianFormToBeSaved.find('.multiAddressFlag').val() == 'false') {
      let saveSearchPhysicianUrl = null;
      let dataRequired = null;
      if (window.location.pathname.indexOf('viewPhysicians') > -1) {
        saveSearchPhysicianUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountSettings.addPhysician}`;
        dataRequired = `${physicianFormToBeSaved.serialize()}` + "&isCheckout=true";
      } else {
        saveSearchPhysicianUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutPhysician.saveSearchPhysician}`;
        const physicianFormErrorData = $('#physicianForm').serialize();
        dataRequired = `${physicianFormToBeSaved.serialize()}&${physicianFormErrorData}`;
      }
      $(globalErrorMsg).addClass('hidden');
      if (!createNewPhysicianSearchAjaxFlag) return false;
      createNewPhysicianSearchAjaxFlag = false;
      formPost(saveSearchPhysicianUrl, dataRequired)
        .then(response => {
          if (response) {
            const jsonResponse = JSON.parse(response);
			if(jsonResponse.cartError != undefined && jsonResponse.cartError != null && String(jsonResponse.cartError).toLocaleLowerCase() == 'true'){
                window.location="/";
                return ;
            }
            if (
              (window.location.pathname.indexOf('viewPhysicians') < 0 &&
                jsonResponse.code === 'SUCCESS') ||
              (window.location.pathname.indexOf('viewPhysicians') > -1 &&
                jsonResponse)
            ) {
              $(noRecordDoctor).hide();
              showNewPhysician();
              if (window.innerWidth >= 992) {
                // Desktop view
                $(window).scrollTop(360); 
              } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
                // Tablet view
                $(window).scrollTop(330); 
              } else {
                // Mobile view
                $(window).scrollTop(440); 
              }
            } else {
              createNewPhysicianSearchAjaxFlag = true;
              $(noRecordDoctor)
                .show()
                .find('.noRecordError_span')
                .text(jsonResponse.message);
            }
          }
          createNewPhysicianSearchAjaxFlag = true;
        })
        .catch(error => {
          createNewPhysicianSearchAjaxFlag = true;
        });
      return false;
    } else {
      multiAddressArray = [];

      physicianFormToBeSaved
        .parents('.account-addnewdoc-search-results-table-body')
        .find('.add-user-address')
        .find('input')
        .each(function(element, index) {
          multiAddressObj.providerId = $(this).attr('data-providerid');
          multiAddressObj.locationId = $(this).attr('data-locationid');
          multiAddressObj.address = $(this).attr('data-address');
          multiAddressObj.city = $(this).attr('data-city');
          multiAddressObj.state = $(this).attr('data-state');
          multiAddressObj.zipCode = $(this).attr('data-zipCode');
          multiAddressObj.phoneNumber = $(this).attr('data-phoneNumber');
          multiAddressObj.npi = $(this).attr('data-npi');
          multiAddressArray.push(multiAddressObj);
          multiAddressObj = {};
        });

      ACC.colorbox.open('', {
        html: $('#selectMultiAddress').html(),
        onLoad: $('#cboxOverlay').css('position', 'fixed'),
        width: checkWidth(),
        height: checkHeight(),
        className: 'account-idc-remove-doctor'
      });

      $('table .tbody-multiple-address').html('');

      multiAddressArray.forEach(element => console.log(element));

      $.each(multiAddressArray, function(j, item) {
        console.log(j);
        let radioBtn = $(
          '<tr><td class="selection-group"><input type="radio" name="selectMultiAddressRadio" id="' +
            '" data-providerId="' +
            item.providerId +
            '" data-locationId="' +
            item.locationId +
            '" data-address="' +
            item.address +
            '" data-city="' +
            item.city +
            '" data-state="' +
            item.state +
            '" data-zipCode="' +
            item.zipCode +
            '" data-phoneNumber="' +
            item.phoneNumber +
            '" data-npi="' +
            item.npi +
            '" class="form-check-input selectMultiAddressRadio"> </td>' +
            '<td>' +
            item.address +
            '</td>' +
            '<td>' +
            item.city +
            '</td>' +
            '<td>' +
            item.state +
            '</td>' +
            '<td>' +
            item.phoneNumber +
            '</td>' +
            '</tr>'
        );
        radioBtn.appendTo('table .tbody-multiple-address');
      });

      ACC.colorbox.resize();
    }
  }

  function cancelAddSearchPhysician() {
    showNewPhysician();
  }

  function validateselectDoctor() {
    const doctorVal = $(errorPageSelectDoctor).val();
    if (doctorVal === addNewPhysician) {
      errorAddDoctorPage();
    }
    else if (doctorVal !== '') {
      $(doctorRltId).val(doctorVal);
      $(errorPageNextButton).prop('disabled', false);
    }
     else {
      $(doctorRltId).val(doctorVal);
      $(errorPageNextButton).prop('disabled', true);
    }
  }

  function errorAddDoctorPage() {
    $(defaultDoctor).addClass('hidden');
    $(addNewDoctor).removeClass('hidden');
    if (location.pathname.indexOf('checkout') > 0) {
      $(checkoutSearchPhysicianCancel).removeClass('hidden');
      productCode = $(productCodeValue).text();
      if (productCode !== '' || productCode !== undefined) {
        setvariableValue('productCode', productCode);
      }
    }
  }

  function hideDoctorDetails() {
    const parentCls = $(this).parents(searchDoctorListRowContainer);
    parentCls.find(showDoctorDetail).removeClass('hidden');
    parentCls
      .find(searchDoctorListReview)
      .addClass('hidden')
      .removeClass('d-flex');
    parentCls.find(hideDoctorDetail).addClass('hidden');
  }
  function showDoctorDetails() {
    const clsParent = $(this).parents(searchDoctorListRowContainer);
    clsParent.find(showDoctorDetail).addClass('hidden');
    clsParent
      .find(searchDoctorListReview)
      .removeClass('hidden')
      .addClass('d-flex');
    clsParent.find(hideDoctorDetail).removeClass('hidden');
  }

  function selectResolutionOption() {
    $(resolutionType).val($(this).val());
    if ($(this).val() === resolveAddSelectDoctor) {
      $(errorPageAddDoctor).prop('disabled', false);
      $(errorPageSelectDoctor).selectmenu('enable');
      $(errorPageNextButton).prop('disabled', true);
      resolutionCode = $(this).val();
      setvariableValue('resolutionCode', resolutionCode);
      $('.reconfirm-signin-physician').addClass('hidden');
    }
    else if ($(this).val() === RECONFIRM_SIGINING_PHYSICIAN) {
      $(errorPageSelectDoctor).selectmenu('disable');
      $(errorPageNextButton).prop('disabled', true);      
      $(errorPageSelectDoctor).val('');
      $(`${physicianPhone},${physicianFax}`).val('').removeClass('error-msg-textbox');
      $(`${physicianPhone},${physicianFax}`).next().addClass('hidden');
      $(errorPageSelectDoctor).selectmenu('refresh');
      resolutionCode = $(this).val();
      setvariableValue('resolutionCode', resolutionCode);
      $('.reconfirm-signin-physician').removeClass('hidden');
    }
     else {
      $(errorPageAddDoctor).prop('disabled', true);
      $(errorPageSelectDoctor).selectmenu('disable');
      $(errorPageNextButton).prop('disabled', false);      
      $(errorPageSelectDoctor).val('');
      $(errorPageSelectDoctor).selectmenu('refresh');
      resolutionCode = $(this).val();
      setvariableValue('resolutionCode', resolutionCode);
      $('.reconfirm-signin-physician').addClass('hidden');
    }
  }

  function checkWidth() {
    if (window.innerWidth >= 992) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  }

  function checkHeight() {
    if (window.innerHeight >= 992) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 992) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  }

  function validateInputsFields(event) {
    var phone = $(physicianPhone).val();
    var fax = $(physicianFax).val();    
    if($(event.target).hasClass('physician-phone')){
      if(phone.length == 0 || (phone.length == 12 && randomNumberRegex.test(phone))) {
	      $(physicianPhoneInfo).val(phone);
	      $(physicianPhone).next().addClass('hidden');
	      $(physicianPhone).removeClass('error-msg-textbox');
	    }
	    else {
	      $(physicianPhone).next().removeClass('hidden');
	      $(physicianPhone).addClass('error-msg-textbox');
	    }
    }
    if($(event.target).hasClass('physician-fax')){
    	if (fax.length == 12 && randomNumberRegex.test(fax)) {
	      $(physicianFaxInfo).val(fax);
	      $(physicianFax).next().addClass('hidden');
	      $(physicianFax).removeClass('error-msg-textbox');
	    }
	    else {
	      $(physicianFax).next().removeClass('hidden');
	      $(physicianFax).addClass('error-msg-textbox');
	    }
    }

    if($(physicianPhone).next().hasClass('hidden') && $(physicianFax).next().hasClass('hidden') && fax.length == 12) {
      $(errorPageNextButton).prop('disabled', false);
    } else {
      $(errorPageNextButton).prop('disabled', true);
    }
  }

  function preventNextStepButton(){
    if(!nextStepButtonFlag){
      nextStepButtonFlag = true;
      $('#physicianForm').submit();
    }
  }

  function init() {
    $(errorPageSelectDoctor).selectmenu();
    $(doc).on('click', physicianFormSearchCancel, cancelAddSearchPhysician);
    $(doc).on('click', saveSearchPhysician, submitSaveSearchPhysician);
    $(doc).on('selectmenuchange', errorPageSelectDoctor, validateselectDoctor);
    $(doc).on('click', errorPageAddDoctor, errorAddDoctorPage);
    $(doc).on('click', showDoctorDetail, showDoctorDetails);
    $(doc).on('click', hideDoctorDetail, hideDoctorDetails);
    $(doc).on('click', selectResolutionOptions, selectResolutionOption);
    $(doc).on('change keyup', '.physician-phone', validateInputsFields);
    $(doc).on('change keyup', '.physician-fax', validateInputsFields);
    $(doc).on('click', errorPageNextButton, preventNextStepButton);
  }
  init();
})(jQuery, document);